<users-list *ngIf="isAdmin"></users-list>
<p *ngIf="!isAdmin">У вас нет прав на просмотр этого раздела</p>
